import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ButtonClearFilters } from '@/ui-kit/table-filters/ButtonClearFilter';
import { ButtonFilter } from '@/ui-kit/table-filters/ButtonFilter';
import { FormFilters } from '@/ui-kit/table-filters/FormFilters';
import { parseBasesPeriod, PeriodFilter } from '@/ui-kit/table-filters/PeriodFilter';
import { SearchFilter } from '@/ui-kit/table-filters/SearchFilter';
import { SelectFilter } from '@/ui-kit/table-filters/SelectFilter';

import { isTWalletTypeId, TWalletTypeId } from '@/features/wallets/store/models/wallet.model';
import { TAllWalletsFiltersFields } from '@/features/wallets/store/types/agent-wallets.types';

export interface IAllWalletsFiltersProps {
  fields: TAllWalletsFiltersFields;
  clearFunction?: () => void;
}

export function AllWalletsFilters({ fields, clearFunction }: IAllWalletsFiltersProps) {
  const { t } = useTranslation();

  const handleTypeIdChange = useCallback(
    (values: string[]) => {
      const buttonValue = Number(values[0]);
      const fieldValue: TWalletTypeId = isTWalletTypeId(buttonValue) ? buttonValue : undefined;
      if (fieldValue) {
        fields.typeId.handleChange(fieldValue);
      }
    },
    [fields.typeId],
  );

  return (
    <FormFilters className="justify-between" data-testid="allWallets-filters">
      <div>
        <ButtonFilter options={fields.typeId.values} selected={[fields.typeId.value]} onChange={handleTypeIdChange} />
      </div>
      <div className="flex gap-3">
        <SearchFilter
          value={fields.search.value}
          onChange={fields.search.handleChange}
          options={fields.search.options}
          placeholder={t('components.molecules.search.placeholder')}
          className="w-[240px]"
        />
        <SelectFilter field={fields.status} label={t('pages.currentProfiles.wallets.wallet.walletStatus')} />
        <PeriodFilter
          field={fields.createdDate}
          label={t('components.filters.date.creationDate')}
          selectBase={parseBasesPeriod(t)}
        />
        {!!clearFunction ? <ButtonClearFilters onClick={() => clearFunction()} /> : <></>}
      </div>
    </FormFilters>
  );
}
